import React from 'react';

interface KickerProps {
  children: React.ReactNode;
  muted?: boolean;
  className?: string;
}

export default function Kicker({ children, muted = false, className = '' }: KickerProps) {
  return (
    <div
      className={`font-mono text-[11px] font-medium uppercase tracking-[1.4px] flex items-center gap-2 ${
        muted ? 'text-text-muted' : 'text-accent'
      } ${className}`}
    >
      <span className="inline-block w-[10px] h-px bg-current" />
      {children}
    </div>
  );
}
